<!-- @format -->
<div
	[id]="'informationalsBlock' + addlData.tagSectionNum"
	class="informationals-page-item hmf-px-s hmf-px-m-0 hmf-my-l hmf-mb-m-xxl"
	[innerHTML]="block"
	*ngFor="let block of blocks"
	commonAutoATags></div>
